import React from 'react';
import { Input, Button, CheckboxTable, Select, PaperClip, Modal } from 'components';
import { FormalityService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals } from 'utils';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { AddIcon, CloseIcon } from 'assets/icons';

interface Props {
  title?: string;
  onClose?: any;
  item?: any;
  areas?: any;
}

const format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;

class CreateFormality extends React.Component<Props> {
  state = {
    form: {
      name: '',
      area_id: '',
      template: '',
      tag: '',
      name_tag: '',
    },
    areas: this.props.areas || [],
    visible: false,
    tags: [],
    reserved_tags: [],
    editing_tag: null,
  };

  componentDidMount() {
    if (this.props.item) {
      this.setState({
        form: {
          ...this.state.form,
          name: this.props.item?.name || '',
          area_id: this.props.item?.area_id || '',
          template: this.props.item?.template || '',
        },
      });
    }

    this.load();
  }

  load = async () => {
    const res: any = await FormalityService.admin.view({
      formality_id: this.props.item?.id,
    });
    this.setState({
      tags:
        res.formality?.tags.map((i: any) => {
          return {
            id: i.id,
            name_tag: i.name,
            tag: i.tag,
          };
        }) || [],
      reserved_tags: res.reserved_tags || [],
    });
  };

  submit = async (e: any) => {
    e.preventDefault();

    if (this.props.item != null) {
      await FormalityService.admin.update({
        formality_id: this.props.item?.id,
        ...this.state.form,
        tags: JSON.stringify(this.state.tags),
      });
      Globals.showSuccess('Se ha modificado la plantilla correctamente');
      this.props.onClose();
    } else {
      await FormalityService.admin.create({
        ...this.state.form,
        tags: JSON.stringify(this.state.tags),
      });
      Globals.showSuccess('Se ha creado la plantilla correctamente');
      this.props.onClose();
    }
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  onClose = () => {
    this.setState({
      visible: false,
      editing_tag: null,
      form: {
        ...this.state.form,
        tag: '',
        name_tag: '',
      },
    });
  };

  openTag = () => {
    this.setState({
      visible: true,
    });
  };

  editTag = (e: any, item: any, index: number) => {
    e.preventDefault();
    this.setState({
      visible: true,
      editing_tag: { id: item.id, index },
      form: {
        ...this.state.form,
        name_tag: item.name_tag,
        tag: item.tag,
      },
    });
  };

  clean = (tag: string) => {
    return Globals.clean(tag).replace(' ', '_').toLowerCase();
  };

  submitTag = async (e: any) => {
    e.preventDefault();

    if (!this.state.form.tag) {
      Globals.showError('Por favor, ingrese un nombre para el campo');
      return;
    }

    const tag = this.clean(this.state.form.tag);
    const editing: any = this.state.editing_tag;

    const isDuplicate =
      this.state.reserved_tags.find((item: any) => item.name === tag) ||
      this.state.tags.find(
        (item: any, index: number) => item.name === tag && (!editing || index !== editing.index),
      );

    if (isDuplicate) {
      Globals.showError('Lo sentimos, ya hay otro campo con ese nombre');
      return;
    }

    if (editing) {
      if (editing.id != null) {
        await FormalityService.admin.updateTag({
          formality_tag_id: editing.id,
          name: this.state.form.name_tag,
          tag,
        });

        Globals.showSuccess('Se ha modificado el campo correctamente');
      }

      let tags: any = [...this.state.tags];
      tags[editing.index] = {
        id: editing.id,
        name_tag: this.state.form.name_tag,
        tag,
      };

      this.setState({
        tags,
        visible: false,
        editing_tag: null,
        form: {
          ...this.state.form,
          tag: '',
          name_tag: '',
        },
      });
      return;
    }

    let tags: any = [...this.state.tags];
    tags.push({
      tag,
      name_tag: this.state.form.name_tag,
    });
    this.setState({
      tags,
      visible: false,
      form: {
        ...this.state.form,
        tag: '',
        name_tag: '',
      },
    });
  };

  removeTag = (e: any, index: number) => {
    e.preventDefault();
    let tags = [...this.state.tags];
    tags.splice(index, 1);
    this.setState({
      tags,
    });
  };

  render() {
    const { visible } = this.state;

    return (
      <div id='modal-create-formality'>
        <Modal
          className='modal-add-tag'
          visible={visible}
          title={this.state.editing_tag ? 'Editar campo' : 'Campo'}
          onClose={() => this.onClose()}
        >
          <form id='modal-add-tag' onSubmit={this.submitTag}>
            <Input
              color='white'
              value={this.state.form.name_tag}
              name='name_tag'
              label='Nombre del campo'
              onChange={this.change}
            />
            <Input
              color='white'
              value={this.state.form.tag}
              name='tag'
              label='Etiqueta'
              onChange={this.change}
            />
            <p className='note'>
              El nombre no debe tener espacios en blanco o caracteres especiales.
              <br />
              Tenga en cuenta que al guardar se modificará automáticamente los valores de esta
              etiqueta en la plantilla.
            </p>
            <div className='text-center'>
              <Button type='submit'>Guardar</Button>
            </div>
          </form>
        </Modal>

        <div className='row'>
          <form onSubmit={this.submit} className='col-md-4'>
            <div className='container-inputs'>
              <div className='row'>
                <div className='col-md-12'>
                  <Select
                    color='white'
                    placeholder='Seleccionar'
                    label='Tipo de derecho'
                    name='area_id'
                    onChange={this.change}
                    value={this.state.form.area_id}
                    options={this.state.areas.map((item: any) => {
                      return {
                        value: item.id,
                        label: item.name,
                      };
                    })}
                  />
                </div>
                <div className='col-md-12'>
                  <Input
                    color='white'
                    value={this.state.form.name}
                    name='name'
                    label='Nombre del documento'
                    onChange={this.change}
                  />
                </div>
                <div className='col-md-12'>
                  <h4>Campos dinámicos</h4>
                  <p>Campos por defecto del registro de usuario</p>
                  {this.state.reserved_tags.map((item: any) => {
                    return (
                      <div className='tag'>
                        <p>{item.name}</p>
                      </div>
                    );
                  })}
                </div>
                <div className='col-md-12'>
                  <div className='row' style={{ marginTop: '10px' }}>
                    <div className='col-md-6'>
                      <h4 style={{ marginTop: '7px' }}>Campos adicionales</h4>
                    </div>
                    <div className='col-md-6 text-right'>
                      <Button type='button' className='btn-add' onClick={() => this.openTag()}>
                        <img src={AddIcon} />
                        Nuevo campo
                      </Button>
                    </div>
                  </div>
                  {this.state.tags.map((item: any, index: number) => {
                    return (
                      <div className='tag'>
                        <p
                          className='tag-editable'
                          onClick={(e: any) => this.editTag(e, item, index)}
                        >
                          {item.tag}
                        </p>
                        <a href='#' onClick={(e: any) => this.removeTag(e, index)}>
                          <img src={CloseIcon} />
                        </a>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className='text-center'>
              <Button type='submit'>Guardar</Button>
            </div>
          </form>
          <div className='col-md-8'>
            <ReactQuill
              theme='snow'
              value={this.state.form.template}
              modules={{
                toolbar: [
                  [{ header: [1, 2, 3, false] }],
                  ['bold', 'italic', 'underline'],
                  [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                ],
              }}
              onChange={(event) => {
                this.setState({
                  form: {
                    ...this.state.form,
                    template: event,
                  },
                });
              }}
            />
            <p className='note'>
              Para agregar los campos al documento debe indicar el nombre del campo encerrado entre
              los simbolos "$[]". Ejemplo: "$[prueba]"
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default CreateFormality;
